// src/feature-module/router/PrivateRoute.jsx
import React from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import MainLoader from "../../core/common/loader/MainLoader.jsx";

// Routes accessible even when trial expired or access paused
const ALLOWED_WHEN_LOCKED = [
  "/crm/upgradePlan",
  "/crm/billing",
  "/crm/settings/profile",
  "/crm/setting/security",
  "/crm/help-and-support",
  "/crm/help-and-support/myTickets",
];

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem("token");
  const { id, role, error, planStatus, trialEndsAt, accessPausedByAdmin } = useSelector((state) => state.profile);
  const location = useLocation();

  if (error || !token) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  if (id === "") {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100 w-100">
        <MainLoader />
      </div>
    );
  }

  if (role === "superadmin") {
    return <Navigate to="/admin/companies-list" state={{ from: location }} replace />;
  } else if (role === "user") {
    return <Navigate to="/agent/dashboard" state={{ from: location }} replace />;
  }

  // Check if companyAdmin access is locked
  if (role === "companyAdmin") {
    const trialExpired = planStatus === "trial" && trialEndsAt && new Date(trialEndsAt) < new Date();
    const planExpired = planStatus === "expired" || planStatus === "cancelled";
    const isLocked = trialExpired || planExpired || accessPausedByAdmin === true;

    if (isLocked && !ALLOWED_WHEN_LOCKED.includes(location.pathname)) {
      return <Navigate to="/crm/upgradePlan" state={{ from: location, locked: true }} replace />;
    }
  }

  return children;
};

export default PrivateRoute;
